import React from "react";
import ReactDOM from "react-dom";
import { createStore, applyMiddleware, compose } from "redux";
import { Provider } from "react-redux";
import thunk from "redux-thunk";
import "bootstrap/dist/css/bootstrap.min.css";
import { PersistGate } from "redux-persist/integration/react";
import { persistStore } from "redux-persist";
import "./index.css";
import App from "./components/App";
import reportWebVitals from "./reportWebVitals";
import reducers from "./reducers/index";
import "antd/dist/antd.min.css";
import "react-image-crop/dist/ReactCrop.css";
import { ConfigProvider } from "./utils/contexts/ConfigContext";
import { QueryClient, QueryClientProvider } from "react-query";
import { GoogleOAuthProvider } from "@react-oauth/google";
import 'material-symbols';

//For Redux Dev Tools.........................................................................
const composeEnhancers = window.__REDUX_DEVTOOLS_EXTENSION_COMPOSE__ || compose;
const store = createStore(
  reducers,

  composeEnhancers(applyMiddleware(thunk))
);
const persister = persistStore(store);
//.............................................................................................

//For react Query...............................................................................
const queryClient = new QueryClient();
//.............................................................................................
const GOOGLE_CLIENT_ID = "259504799474-3q2tvrsu5gf83rofjevpr5bpdpun3jii.apps.googleusercontent.com";


ReactDOM.render(
  <Provider store={store}>
    <PersistGate loading={null} persistor={persister}>
      <ConfigProvider>
        <QueryClientProvider client={queryClient}>
          <GoogleOAuthProvider clientId={GOOGLE_CLIENT_ID}>
            <App />
          </GoogleOAuthProvider>
        </QueryClientProvider>
      </ConfigProvider>
    </PersistGate>
  </Provider>,
  document.getElementById("root")
);

reportWebVitals();
